import React from 'react'
import {ErrorSummary} from './ErrorsAndAlert/ErrorSummary/ErrorSummary'

export const ProcessingErrorMessage: React.VFC = () => {
  return (
    <ErrorSummary
      testId={'processing-error-message'}
      display={true}
      headline={'現在システムメンテナンス中です。'}
      detail={
        '毎月1日 AM0:00 〜 AM5:00 はシステムメンテナンスのため、' +
        '「契約内容の閲覧」及び「お支払いに関する情報変更」並びに「退会に関する操作」はできません。\n' +
        'メンテナンス終了後に実施してください。'
      }
    />
  )
}
